import { render, staticRenderFns } from "./IDPHistorys.vue?vue&type=template&id=67db0f45"
import script from "./IDPHistorys.vue?vue&type=script&lang=js"
export * from "./IDPHistorys.vue?vue&type=script&lang=js"
import style0 from "./IDPHistorys.vue?vue&type=style&index=0&id=67db0f45&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports